import { DEFAULT_TEMPLATE_LANGUAGE } from "../constants/templateLanguages";

/** Subtle squared corners for Meta-style template creator UI */
export const TC_RADIUS = "rounded-[3px]";

export const CATEGORIES = [
  { value: "MARKETING", label: "Marketing" },
  { value: "UTILITY", label: "Utility" },
  { value: "AUTHENTICATION", label: "Authentication" },
];

export const TEMPLATE_SUBTYPES = {
  MARKETING: [
    {
      value: "default",
      label: "Default",
      description:
        "Send messages with media and customised buttons to engage your customers.",
      enabled: true,
    },
    {
      value: "catalogue",
      label: "Catalogue",
      description:
        "Send messages that drive sales by connecting your product catalogue.",
      enabled: false,
    },
    {
      value: "flows",
      label: "Flows",
      description:
        "Send a form to capture customer interests, appointment requests or run surveys.",
      enabled: false,
    },
    {
      value: "order_details",
      label: "Order details",
      description: "Send messages through which customers can pay you.",
      enabled: false,
    },
    {
      value: "calling_permissions",
      label: "Calling permissions request",
      description:
        "Ask customers if they want to receive calls from you on WhatsApp.",
      enabled: false,
    },
  ],
  UTILITY: [
    {
      value: "default",
      label: "Default",
      description: "Send messages about an existing order or account.",
      enabled: true,
    },
    {
      value: "flows",
      label: "Flows",
      description:
        "Send a form to capture customer interests, appointment requests or run surveys.",
      enabled: false,
    },
    {
      value: "order_status",
      label: "Order status",
      description: "Send a message to customers about the status of an order.",
      enabled: false,
    },
    {
      value: "order_details",
      label: "Order details",
      description: "Send messages through which customers can pay you.",
      enabled: false,
    },
    {
      value: "calling_permissions",
      label: "Calling permissions request",
      description:
        "Ask customers if they want to receive calls from you on WhatsApp.",
      enabled: false,
    },
  ],
  AUTHENTICATION: [
    {
      value: "one_time_passcode",
      label: "One-time passcode",
      description: "Send codes to verify a transaction or login.",
      enabled: true,
    },
  ],
};

export const VARIABLE_TYPES = [
  { value: "numbered", label: "Number" },
  { value: "named", label: "Named" },
];

export const MEDIA_SAMPLES = [
  { value: "none", label: "None" },
  { value: "image", label: "Image" },
  { value: "video", label: "Video" },
  { value: "document", label: "Document" },
  { value: "location", label: "Location" },
];

export const CODE_DELIVERY_OPTIONS = [
  {
    value: "zero_tap",
    label: "Zero-tap auto-fill",
    description:
      "This is recommended as the easiest option for your customers. Zero-tap will automatically send code without requiring your customer to tap a button. An auto-fill or copy code message will be sent if zero-tap and auto-fill aren't possible.",
  },
  {
    value: "one_tap",
    label: "One-tap auto-fill",
    description:
      "The code sends to your app when customers tap the button. A copy code message will be sent if auto-fill isn't possible.",
  },
  {
    value: "copy_code",
    label: "Copy code",
    description:
      "Basic authentication with quick setup. Your customers copy and paste the code into your app.",
  },
];

export const ACTIVE_FOR_OPTIONS = Array.from({ length: 30 }, (_, i) => ({
  value: i + 1,
  label: `${i + 1} day${i > 0 ? "s" : ""}`,
}));

export const CTA_BUTTON_TYPES = [
  { value: "URL", label: "Visit website", icon: "ExternalLink" },
  { value: "PHONE_NUMBER", label: "Call Phone Number", icon: "Phone" },
  { value: "COPY_OFFER_CODE", label: "Copy offer code", icon: "Copy" },
  { value: "FLOW", label: "Complete flow", icon: "Workflow" },
];

export const BUTTON_LIMITS = {
  TOTAL: 10,
  QUICK_REPLY: 10,
  URL: 2,
  PHONE_NUMBER: 1,
  COPY_OFFER_CODE: 1,
  FLOW: 1,
};

export const CHAR_LIMITS = {
  TEMPLATE_NAME: 512,
  HEADER_TEXT: 60,
  BODY: 1024,
  FOOTER: 60,
  BUTTON_TEXT: 25,
  PHONE_NUMBER: 20,
  WEBSITE_URL: 2000,
  OFFER_CODE: 20,
};

export const INITIAL_TEMPLATE_STATE = {
  name: "",
  language: DEFAULT_TEMPLATE_LANGUAGE,
  category: "MARKETING",
  subtype: "default",
  variableType: "numbered",
  mediaSample: "none",
  headerText: "",
  headerVariables: [],
  body: "",
  bodyVariables: [],
  footer: "",
  ctaButtons: [],
  quickReplyButtons: [],
  headerFile: null,
  headerFilePreview: null,
  headerMediaUrl: null,
  codeDelivery: "copy_code",
  addSecurityRecommendation: true,
  addExpiryTime: true,
  expiryMinutes: 10,
};
